<template>
  <div v-scroll="onScroll" v-resize="onResize" class="supplierorder">
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data :references.sync="formReferences" :model="supplierObj" ref="supplierOrderRef" v-else>
      <template slot="title-actions">
        <template v-for="(button, index) in formReferences.end_buttons">
          <v-btn class="mx-1" :key="index" :loading="button.loading" :id="button.name" v-if="button.is_show" @click="button.click" :color="button.color" :disabled="button.disabled"
            :class="button.class || ''"> {{ button.label }} </v-btn>
        </template>
      </template>
      <template slot="supplier_attachment">
        <div v-for="(element, index) in orderAttachment" :key="index">
          <v-flex lg12 class="py-1 px-2">
            <a @click="downloadAttachment(index)">{{ element.fileoriginalname }}</a> <v-icon :disabled="supplierObj.status === 'received'" @click="deleteAttachment(index)" class="attachment-icon-delete">delete</v-icon>
          </v-flex>
        </div>
      </template>
      <template slot="custom_fields">
        <v-layout wrap class="pa-0">
          <v-flex sm12 lg6 xs12>
            <v-layout wrap class="pa-0">
              <v-flex sm6 lg6>
                <v-text-field hide-details v-model="supplierObj.salesreference" dense outlined :label="$t('message.orders.salesReference')"></v-text-field>
                 <v-autocomplete dense outlined class="mt-3" v-model="supplierObj.deliverto" :label="$t('message.whOrder.deliverTo')"
                  ref="searchSupplier"
                  @keyup="$event.keyCode !== 13 ? loadCustomers('searchSupplier', $event) : ''"
                  :disabled="disableStatusChange" :loading="customersLoading" @change="findDeliverToName" clearable
                  :hint="`${$t('message.whOrder.leaveBlank')} ${companyName || ''}`" persistent-hint :items="listOfCustomers" item-text="name" item-value="id"
                  :item-disabled="isCustomerDisabled"
                 >
                  <template v-slot:item="{ item }">
                    <span :style="{ color: item.isactive ? 'inherit' : '#ec1b1b' }">
                      {{ item.name }}
                    </span>
                  </template>
                 </v-autocomplete>
                  <div class="mt-3">
                    <strong>{{ $t("message.common.total") }}: {{ totalPrice | replaceDotWithComma }}&nbsp;{{ supplierCurrency }}</strong>
                  </div>
              </v-flex>
              <v-flex sm6 lg6>
                <v-text-field hide-details v-model="supplierObj.labeled" dense outlined :label="$t('message.whOrder.labeled')"></v-text-field>
                <v-autocomplete dense hide-details outlined class="mt-3" v-model="supplierObj.deliveryaddress"
                    :label="$t('message.orders.deliveryAddress')" clearable
                    @click:append="addNewAddress"
                    :append-icon="supplierObj.deliverto ? 'add_circle' : ''"
                    :disabled="disableStatusChange" :loading="addressLoading" :items="listOfAddress" :item-text="getCombinedAddress" item-value="id"
                  ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm12 lg6 xs12>
            <v-layout wrap class="pa-0">
              <v-flex sm12 lg6>
                <v-textarea outlined hide-details rows="3" dense v-model="supplierObj.comments" :disabled="supplierObj.status === constants.RECEIVED" @change="autoSave" :label="$t('message.whOrder.comments')"></v-textarea>
              </v-flex>
              <v-flex sm12 lg6>
                <v-textarea outlined hide-details rows="3" dense v-model="supplierObj.internal_comments" @change="autoSave" :label="$t('message.whOrder.internalComments')"></v-textarea>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-row class="mx-0">
            <v-col cols="12" lg="5" class="py-0">
              <b v-show="lastUpdatedShow">{{ $t("message.orders.lastUpdated") }}&nbsp; by
                {{ lastUpdated }}</b><br />
              <span v-show="mailSentObj.sentTo">{{ $t("message.whOrder.emailSentTo", { email: mailSentObj.sentTo, user: mailSentObj.sentBy, date: mailSentObj.sentOn }) }}</span>
            </v-col>
            <v-col cols="12" lg="2" class="py-0 mb-3">
              <v-btn color='primary' v-if="supplierObj.status === 'inprogress'" :loading="receiveAllLoader" @click="receiveAllHandler">
                {{ $t("message.whOrder.receiveAll") }}
              </v-btn>
            </v-col>
            <v-col cols="12" lg="5" v-if="supplierObj.id" class="py-0">
              <v-layout wrap class="px-3 mt-1">
                <v-spacer></v-spacer>
                <v-btn color='info' @click="attachmentsDialog = true">
                  <v-icon color="white" class="mdi-rotate-315">mdi-attachment</v-icon> {{ $t('message.product.attachments') }}
                  <span v-if="attachmentsCountLoading">&nbsp;(<span>
                    <v-progress-circular
                      indeterminate
                      color="white"
                      x-small
                      :size="12"
                      :width="2"
                    ></v-progress-circular>
                  </span>)</span>
                  <span v-else>&nbsp;({{attachmentsCount}})</span>
                </v-btn>
              </v-layout>
            </v-col>
          </v-row>
        </v-layout>
      </template>
      <template slot="extraDetails" class="mb-3">
        <!-- <v-row v-if="supplierObj.id" class="mx-0">
          <v-col cols="12" class="py-0">
            <label class="pa-2" v-if="supplierObj.sharepoint_link">{{ $t('message.onedriveSettings.odLink') }}: <a target="_blank" :href="supplierObj.sharepoint_link">{{ supplierObj.sharepoint_link }}</a></label>
            <v-expansion-panels v-if="!fieldsLoading">
              <attachments :model.sync="supplierObj" :key="reInit" :module="SP_SUPPLIER_ORDER"></attachments>
            </v-expansion-panels>
          </v-col>
        </v-row> -->
        <v-form ref="orderItems">
          <v-row>
            <v-col cols="10" class="pl-0 pr-0">
              <v-row>
                <v-col cols="3" sm="2" md="1" lg="1" class="pa-0" v-if="supplierObj.supplierid && isItemsSelectedForDelete">
                  <v-btn class="ml-2 mb-2" color="primary" @click="removeSelectedProducts" :disabled="itemsDelete">{{ $t('message.common.delete') }}</v-btn>
                </v-col>
                <v-col cols="1" sm="1" md="1" lg="1" class="pa-0" v-if="supplierObj.id">
                  <v-btn class="ml-2 mb-2 pa-0" style="min-width: 42px;" color="primary" @click="exportOrderItems" :loading="exportLoading">
                    <v-icon>mdi-file-excel</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="4" sm="3" md="2" class="pa-0" v-if="supplierObj.supplierid && !disableFormFields" @click="addProductsToList">
                  <v-btn class="ml-2 mb-2" color="primary" :loading="loadingSupplierProducts">{{ $t('message.whOrder.orderProposal') }}</v-btn>
                </v-col>
                <v-col cols="3" sm="2" md="2" class="pa-0" v-if="supplierObj.supplierid && !disableFormFields">
                  <v-checkbox dense color="primary" v-model="isMainSupplier" :label="$t('message.order.asMainSupplier')"></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="2" class="text-right pl-0 pr-2 mt-2">
              <v-btn fab x-small color="primary" v-if="showScrollToBottom" @click="goToBottom"><v-icon>mdi-chevron-down</v-icon></v-btn>
            </v-col>
          </v-row>
          <v-simple-table dense class="order_item_table mt-2">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">#</th>
                  <th class="text-left">{{ $t('message.product.number') }}</th>
                  <th class="pa-0" @click="showProductNameSearch = true" style="cursor: pointer;">
                    <div v-if="!showProductNameSearch">
                      {{ $t('message.customer.name') }}*
                      <v-icon small>mdi-magnify</v-icon>
                      <v-progress-circular v-if="loadingProducts" indeterminate color="primary"></v-progress-circular>
                    </div>
                    <v-text-field
                      v-else
                      v-model="productNameSearchText" class="product-search"
                      dense
                      hide-details
                      outlined
                      ref="productNameSearchField"
                      @input="filterByProductName"
                      @blur="handleProductNameSearchBlur"
                      @click.stop
                      :placeholder="$t('message.common.search')"
                      clearable
                    ></v-text-field>
                  </th>
                  <th> {{ $t('message.product.unit') }} </th>
                  <th>{{ $t('message.whOrder.orderQty') }}*</th>
                  <!-- <th class="text-right">{{ $t('message.whOrder.minQty') }}</th>
                  <th class="text-right">{{ $t('message.whOrder.orderedQty') }}</th>
                  <th class="text-right">{{ $t('message.whOrder.availQty') }}</th> -->
                  <th v-if="supplierObj.status === 'inprogress' || supplierObj.status === 'received' || supplierObj.status === 'partiallyreceived'">
                    {{ $t('message.layout.loc') }}*
                    <v-btn x-small primary fab>
                      <v-icon @click="fillOutLocations">mdi-checkbox-multiple-marked-outline</v-icon>
                    </v-btn>
                    <v-progress-circular indeterminate v-if="loadingLocations" color="primary"></v-progress-circular>
                  </th>
                  <th v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'ready' && supplierObj.status !== 'draft'">{{ $t('message.whOrder.recQty') }}</th>
                  <th v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'ready' && supplierObj.status !== 'draft'">
                    {{ $t('message.orders.restQty') }}
                  </th>
                  <th v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'ready' && supplierObj.status !== 'draft'">
                    {{ $t('message.order.batchNo') }}
                    <v-progress-circular v-if="loadingBatchNumber" indeterminate color="primary"></v-progress-circular>
                  </th>
                  <th class="text-right">{{ $t("message.whOrder.unitCost") }}</th>
                  <th class="text-right">{{ $t("message.whOrder.discount") }}</th>
                  <th class="text-right">{{ $t("message.whOrder.discounted") }}</th>
                  <th class="text-right">{{ $t('message.common.total') }}</th>
                  <th v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'ready' && supplierObj.status !== 'draft'">{{ $t('message.whOrder.expireDate') }}</th>
                  <th>{{ $t('message.common.comment') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(element, index) in orderItems">
                  <tr v-if="element.is_show !== false" :key="element.id || index" class="pt-4">
                    <v-text-field type="text" class="hidden-sm-and-up hidden-sm-and-down" v-model="element.id"></v-text-field>
                  <td width="1% pr-0 pl-1">
                    <v-checkbox dense hide-details color="primary" v-model="element.isSelected" class="mt-0 pa-0"></v-checkbox><!-- v-if="element.receivedorders && element.receivedorders.length <= 0" -->
                  </td>
                  <td width="8%" class="alignSub pr-0 pl-1">
                    <template v-if="element.olditem ? element.olditem.productid : false">
                      {{ element.productnumber }}
                      <!-- <v-text-field hide-details dense outlined v-model="element.productnumber" :disabled="supplierObj.status === 'received'"></v-text-field> -->
                    </template>
                  </td>
                  <td width="16%" class="alignSub pr-0 pl-1">
                    <template v-if="element.olditem ? element.olditem.productid : false">
                      <v-text-field hide-details dense outlined v-model="element.producttext" :disabled="supplierObj.status === 'received'"></v-text-field>
                    </template>
                    <v-autocomplete v-else v-model="element.productid" :items="element.products" autocomplete="off"
                      @keyup="$event.keyCode !== 13 &&  $event.keyCode !== 9 ? loadProducts(`searchInput${index}`, index, $event) : ''"
                      :ref="`searchInput${index}`" outlined dense
                      @click="toggleAllProducts(index, SHOW)"
                      @focusout="toggleAllProducts(index, HIDE, element.productid)"
                      @change="getActiveProuct(index, element.productid)"
                      item-text="productName" item-value="id" :rules="$_requiredValidation" :disabled="disableFormFields"
                      hide-details :placeholder="$t('message.common.typeHere')" :loading="element.productLoader"></v-autocomplete>
                  </td>
                  <td width="4%" class="alignSub pr-0 pl-1">
                    <v-autocomplete @change="unitCalculation(index)" outlined dense :items="listOfUnitMatrix.filter(x => x.productid === element.productid && x.issupplier)" item-text="productunit_name" autocomplete="off" :rules="$_requiredValidation" v-model="element.unitid"
                      item-value="id" @click:clear="$nextTick(() => element.unitid = null)" ref="unitid" hide-details :disabled="['partiallyreceived', 'received'].includes(supplierObj.status)"></v-autocomplete>
                  </td>
                  <td width="4%" class="alignSub pr-0 pl-1">
                    <v-text-field v-model="element.qty" :disabled="supplierObj.status === 'received'" outlined dense :ref="`qty_${index}`"
                      :rules="element.qty ? $_norwegianNumberValidation : $_requiredValidation" hide-details
                      @keyup="$event.keyCode !== 13 &&  $event.keyCode !== 9 ? checkReceivedQty(index, element.qty): ''" @change="calculateTotalValue(index)" @blur="qtyChanged ? autoSave () : ''"
                      :placeholder="$t('message.common.typeHere')"></v-text-field>
                  </td>
                  <!-- <td width="4%" class="alignSub text-right pr-0 pl-1">
                    {{ element.minqty }}
                  </td>
                  <td width="4%" class="alignSub text-right pr-0 pl-1">
                    {{ element.orderedqty }}
                  </td>
                  <td width="4%" class="alignSub text-right pr-0 pl-1">
                    {{ element.available }}
                  </td> -->
                  <td width="5%" class="alignSub pr-0 pl-1"
                    :class="!element.checked ? '' : 'highlight-location'"
                    v-if="supplierObj.status === 'inprogress' || supplierObj.status === 'received' || supplierObj.status === 'partiallyreceived'">
                    <template v-if="element.receivedorders && element.receivedorders.length > 0">
                      <div v-for="(item) in element.receivedorders" :key="item.id">
                        <v-text-field outlined dense hide-details class="mb-1" v-model="item.locationname" disabled></v-text-field>
                        <!-- <v-autocomplete outlined dense v-model="item.locationid" :rules="item.receivedqty ? $_requiredValidation : []"
                          :items="item.listOfLocation"
                          item-text="name" item-value="id" class="mt-1" autocomplete="off" disabled
                          hide-details :placeholder="$t('message.common.typeHere')">
                        </v-autocomplete> -->
                      </div>
                    </template>
                    <v-text-field hide-details outlined class="mt-1" v-model="element.locationname" dense
                      @click.exact.ctrl="pasteLocationsGlobally($event, index, 'ctrl')"
                      @click.exact="pasteLocationsGlobally($event, index, '')"
                      @paste="onPasteLocation($event, index)"
                      @click.exact.shift="pasteLocationsGlobally($event, index, 'shift')"
                      v-if="supplierObj.status !== 'received' && !element.isMaximumUsed"
                      :rules="element.productnotinventoryitem ? [] : (element.receivedqty ? $_requiredValidation : [])"
                      @change="checkIfLocationValid(index, element.locationname)"></v-text-field>
                    <!-- <v-autocomplete v-model="element.locationid" :items="element.listOfLocation" autocomplete="off"  class="mt-1"
                      @keyup="$event.keyCode !== 13 ? loadLocation(`searchLocation${index}`, index, $event, element.productid) : ''"
                      :ref="`searchLocation${index}`" outlined dense
                      @click="toggleLocations(index, SHOW)"
                      v-if="supplierObj.status !== 'received' && !element.isMaximumUsed"
                      @focusout="toggleLocations(index, HIDE, element.locationid)"
                      item-text="name" item-value="id"
                      :rules="element.receivedqty ? $_requiredValidation : []"
                      :loading="element.locationLoading"
                      hide-details :placeholder="$t('message.order.searchLocation')">
                      <template v-slot:no-data>
                        <span class="pa-1 caption">{{ $t('message.common.noResults') }}</span>
                      </template>
                    </v-autocomplete> -->
                  </td>
                  <td v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'ready' && supplierObj.status !== 'draft'" width="6%" class="alignSub pr-0 pl-1">
                    <template v-if="element.receivedorders && element.receivedorders.length > 0">
                      <div v-for="(item) in element.receivedorders" :key="item.id" style="display: flex;">
                        <v-text-field outlined dense hide-details class="mb-1" v-model="item.receivedqty" disabled></v-text-field>
                         <v-icon @click="reverseTheStock(item.id)">mdi-rotate-left mdi-18px</v-icon>
                      </div>
                    </template>
                    <v-text-field class="mb-1" outlined dense v-if="supplierObj.status !== 'received' && !element.isMaximumUsed"
                      @change="validateQtyHandler(index, element.qty)" v-model="element.receivedqty" hide-details :placeholder="$t('message.common.typeHere')"
                      :rules="element.locationid ? $_requiredValidation : element.receivedqty ? $_norwegianNumberValidation : []"></v-text-field>
                  </td>
                  <td v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'ready' && supplierObj.status !== 'draft'" width="3%" class="alignSub pr-0 pl-1">
                    {{ element.restqty | replaceDotWithComma }}
                  </td>
                  <td v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'ready' && supplierObj.status !== 'draft'" width="5%" class="alignSub pr-0 pl-1">
                    <template v-if="element.isbatch">
                      <template v-if="element.receivedorders && element.receivedorders.length > 0">
                        <div v-for="(item) in element.receivedorders" :key="item.id">
                          <v-text-field outlined dense hide-details class="mb-1" v-model="item.batchnumber" disabled></v-text-field>
                        </div>
                      </template>
                      <v-text-field class="mb-1" outlined dense v-if="supplierObj.status !== 'received' && !element.isMaximumUsed"
                        v-model="element.batchnumber" hide-details :placeholder="$t('message.common.typeHere')" :rules="element.receivedqty ? $_requiredValidation : []"></v-text-field>
                    </template>
                  </td>
                  <td width="6%" class="alignSub text-right pr-0 pl-1">
                    <v-text-field v-model="element.discountedprice" outlined dense :disabled="userDetails.role === 3 || supplierObj.status === 'received'"
                      :rules="element.discountedprice ? $_norwegianNumberValidation : []" hide-details @change="calculateCostNokAndTotal(index)"
                      ></v-text-field>
                  </td>
                  <td width="4%" class="alignSub text-right pr-0 pl-1">
                    <v-text-field v-model="element.discount" outlined dense :disabled="userDetails.role === 3 || supplierObj.status === 'received'"
                      :rules="element.discount ? $_norwegianNumberValidation : []" hide-details @change="calculateCostNokAndTotal(index)"
                      ></v-text-field>
                  </td>
                  <td width="6%" class="alignSub text-right pr-0 pl-1">
                    {{ element.discounted | replaceDotWithComma }}
                  </td>
                  <td width="6%" class="alignSub text-right pr-1 pl-1">
                    {{ element.totalprice | replaceDotWithComma }}
                  </td>
                  <td width="6%" v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'ready' && supplierObj.status !== 'draft'" class="alignSub pr-0 pl-1">
                    <template v-if="element.receivedorders && element.receivedorders.length > 0">
                      <div v-for="(item) in element.receivedorders" :key="item.id">
                        <v-text-field outlined dense hide-details class="mb-1" v-model="item.expirydate" disabled></v-text-field>
                      </div>
                    </template>
                    <v-menu :close-on-content-click="false" v-model="element.expireMenu" transition="scale-transition"
                      offset-y min-width="290px" v-if="supplierObj.status !== 'received' && !element.isMaximumUsed">
                      <template v-slot:activator="{ on }">
                        <v-text-field outlined hide-details dense clearable
                        v-on="on" v-model="element.expirydate"
                        @click:clear="$nextTick(() => element.expireDatePicker = null)"></v-text-field>
                      </template>
                      <v-date-picker color="primary" v-model="element.expireDatePicker"
                      @change="element.expirydate = $formatter.formatDate(element.expireDatePicker, 'YYYY-MM-DD', 'DD.MM.YYYY')"
                      @input="element.expireMenu = false" first-day-of-week='1'></v-date-picker>
                    </v-menu>
                  </td>
                  <td width="15%" class="alignSub pr-0 pl-1">
                    <v-text-field outlined dense v-model="element.comments" type="text" :disabled="element.commentReadonly || disableFormFields" hide-details :placeholder="$t('message.common.typeHere')"></v-text-field>
                  </td>
                  <td class="alignSub pr-0 pl-0" v-if="supplierObj.status !== 'partiallyreceived' && supplierObj.status !== 'received'">
                    <v-btn class="mx-0" text fab dark small color="primary" @click="deleteProductRow(index, element.id)">
                      <v-icon dark>mdi-minus-circle</v-icon>
                    </v-btn>
                  </td>
                </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>
        </v-form>
        <v-btn class="mx-2" fab dark small color="primary" @click="addProductRowHandler" v-if="supplierObj.supplierid && !disableFormFields">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
        <v-fab-transition>
          <v-btn fab bottom small right color="primary" id="scroll__top" fixed v-if="showScrollToTop" @click="scrollToTop">
            <v-icon dark>mdi-chevron-up</v-icon>
          </v-btn>
        </v-fab-transition>
        <!-- Picking qty is greater than ordered -->
        <v-dialog v-model="moreQtyObj.dialog" persistent width="400">
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.common.warning') }} </v-card-title>
            <v-card-text class="pa-5">
              <h4>{{ $t('message.order.orderedQtyHigh') }}</h4>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="moreQtyObj.onSuccess">{{ $t('message.common.yes') }} </v-btn>
              <v-btn color="error" @click="moreQtyObj.onCancel">{{ $t('message.common.no') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Delete order items -->
        <v-dialog v-model="deleteObj.dialog" persistent max-width="400px" class="mt-0">
          <v-card>
            <v-card-title>
              {{ $t('message.common.deleteConfirm') }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-5">
              {{ $t('message.common.areYouSure') }}
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" id="deleteConfirm" @click="deleteObj.onSuccess">{{ $t('message.common.yes') }}</v-btn>
              <v-btn color="primary" id="deleteClose" @click="deleteObj.onClose">{{ $t('message.common.no') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="supplierDialog" width="800" persistent>
          <form-data :references.sync="supplierItemsReference" :model="supplierModel" ref="costItemReference"></form-data>
        </v-dialog>
      </template>
    </form-data>
    <div id="noso_products" style="visibility: hidden;"></div>
    <v-dialog v-model="attachmentsDialog" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>{{ $t('message.product.attachments') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="attachmentsDialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <document-manager class="pa-1 custom-max-width" :modelObj.sync="supplierObj" :module="SP_SUPPLIER_ORDER" :key="reInit"></document-manager>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="downloadObj.dialog" persistent max-width="500px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.order.download') }} {{ $t('message.warehouse.order') }} {{ downloadObj.model ? downloadObj.model.number : '' }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <v-row>
            <v-col cols="6">
              <v-checkbox dense hide-details v-model="downloadObj.withLocs" :label="$t('message.whOrder.withLocations')"></v-checkbox>
            </v-col>
            <v-col cols="6">
              <v-checkbox dense hide-details v-model="downloadObj.withPrices" :label="$t('message.whOrder.withPrices')"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="downloadObj.onSuccess">{{ $t('message.order.download') }}</v-btn>
          <v-btn color="error" @click="downloadObj.onClose">{{ $t('message.common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addressDialog" width="800" persistent>
      <form-data
        :references.sync="addressReference"
        :model="addressModel"
        ref="addressReference"
      ></form-data>
    </v-dialog>
    <v-dialog v-model="contactDialog" width="800" persistent>
      <form-data
        :references.sync="contactReference"
        :model="contactModel"
        ref="contactReference"
      ></form-data>
    </v-dialog>
    <!-- Reverse received qty dialog -->
    <v-dialog v-model="reverseHandler.dialog" persistent width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.common.warning') }} </v-card-title>
        <v-card-text class="pa-5">
          <h4>{{ $t('message.whOrder.reverseReceived') }}</h4>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" :loading="reverseHandler.loading" @click="reverseHandler.onSuccess">{{ $t('message.common.yes') }} </v-btn>
          <v-btn color="success" @click="reverseHandler.onCancel">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '@/components/FormTemplate'
import goTo from 'vuetify/lib/services/goto'
import CONSTANTS from '@/utils/warehouse.json'
import Customer from '@/mixins/Customer/index'
export default {
  data () {
    return {
      totalPriceLoading: false,
      supplierDialog: false,
      supplierLoading: false,
      selectedProduct: {},
      supplierModel: {
        supplierprice: '',
        supplierdiscount: '',
        discounted: '',
        shipmentaddon: '',
        other: '',
        realcost: '',
        realcostnok: '',
        currencyid: '',
        ismain: true
      },
      listOfUnitMatrix: [],
      listOfCurrencyList: [],
      totalExchangeAmount: 0,
      supplierTransformList: ['supplierprice', 'supplierdiscount', 'discounted', 'shipmentaddon', 'other', 'realcost', 'realcostnok'],
      supplierObj: {
        id: this.$route.params.supp_id,
        file: [],
        status: 'draft',
        priority: 'medium',
        datePicker: '',
        dateesPicker: ''
      },
      fieldsLoading: false,
      loading: false,
      orderItems: [],
      listOfProducts: [],
      listOfLocation: [],
      orderAttachment: [],
      disableFormFields: false,
      disableStatusChange: false,
      listOfAllProducts: [],
      loadingProducts: false,
      loadingBatchNumber: false,
      loadingLocations: false,
      loadingSupplierProducts: false,
      companyName: '',
      moreQtyObj: {
        dialog: false
      },
      totalPrice: 0,
      supplierCurrency: '',
      supplierCurrencyId: 0,
      lastUpdated: '',
      mailSentObj: {},
      lastUpdatedShow: false,
      isMainSupplier: true,
      deleteObj: {
        dialog: false
      },
      canReloadDocument: false,
      reInit: 0,
      isAutoSave: false,
      attachmentsDialog: false,
      attachmentsCount: 0,
      attachmentsCountLoading: false,
      qtyChanged: false,
      receiveAllLoader: false,
      showScrollToTop: false,
      showScrollToBottom: false,
      isFromSaleOrder: false,
      customersLoading: false,
      suppliersLoading: false,
      addressLoading: false,
      contactLoading: false,
      canClear: false,
      canContactClear: false,
      allSuppliers: [],
      listOfCustomers: [],
      listOfAddress: [],
      listOfContacts: [],
      downloadObj: {
        dialog: false,
        onSuccess: () => false,
        onClose: () => false
      },
      addressDialog: false,
      contactDialog: false,
      addressModel: {},
      contactModel: {},
      isLoading: false,
      contactsLoading: false,
      reverseHandler: {
        dialog: false,
        loading: false,
        onSuccess: () => false,
        onCancel: () => false
      },
      productNameSearchText: '',
      showProductNameSearch: false,
      searchDebounceTimer: null,
      exportLoading: false
    }
  },
  components: {
    'form-data': FormTemplate,
    // attachments: () => import('@/components/Attachments'),
    'document-manager': () => import('@/components/Documents/ModulesDocuments')
  },
  mixins: [Customer],
  created () {
    this.getAllCurrencyList()
    this.getAllProductUnitMatrices()
  },
  computed: {
    ...mapState(['FORM_TYPE', 'listOfWarehouse', 'listOfLocations', 'userDetails', 'listOfUsers']),
    isItemsSelectedForDelete () {
      return this.orderItems.filter(x => x.isSelected).length >= 1
    },
    pageHeight () {
      return document.body.scrollHeight
    },
    constants () {
      return CONSTANTS
    },
    downloadOptions () {
      return [{
        text: this.$t('message.whOrder.withLocations'),
        value: 'with_locations'
      }, {
        text: this.$t('message.whOrder.withoutLocations'),
        value: 'without_locations'
      }]
    },
    itemsDelete () {
      return this.orderItems.some(x => x.isSelected && x.receivedorders && x.receivedorders.some(y => y.locationid))
    },
    supplierItemsReference () {
      return {
        title: this.supplierModel.id ? this.$t('message.product.updateSupplierItem') : this.$t('message.product.addSupplierItem'),
        properties: [
          {
            model: 'supplierid',
            type: this.FORM_TYPE.AUTO_COMPLETE,
            rules: this.$_requiredValidation,
            label: this.$t('message.order.supplier'),
            items: this.allSuppliers,
            select_text: 'name',
            select_value: 'id',
            disabled: true,
            item_disabled: this.isSupplierDisabled,
            custom_item_slot: true,
            class: 'lg4 sm6'
          },
          {
            model: 'articlenumber',
            type: this.FORM_TYPE.TEXT,
            rules: this.$_requiredValidation,
            label: this.$t('message.product.articleNumber'),
            class: 'lg4 sm6'
          }, {
            model: 'articlename',
            type: this.FORM_TYPE.TEXT,
            rules: this.$_requiredValidation,
            label: this.$t('message.product.articleName'),
            class: 'lg4 sm6'
          }, {
            model: 'currencyid',
            type: this.FORM_TYPE.AUTO_COMPLETE,
            rules: this.$_requiredValidation,
            label: this.$t('message.product.currency'),
            items: this.listOfCurrencyList,
            select_text: 'name',
            select_value: 'id',
            class: 'lg3 sm6',
            change: this.getCurrencyExAmount
          }, {
            model: 'supplierprice',
            type: this.FORM_TYPE.TEXT,
            rules: this.$_norwegianNumberValidation,
            label: this.$t('message.product.supplierPrice'),
            change: this.calculateDiscounted,
            class: 'lg3 sm6'
          }, {
            model: 'supplierdiscount',
            type: this.FORM_TYPE.TEXT,
            rules: this.$_discountValidation,
            label: this.$t('message.product.supplierDiscount'),
            change: this.calculateDiscounted,
            class: 'lg2 sm6'
          }, {
            model: 'discounted',
            type: this.FORM_TYPE.TEXT,
            rules: this.$_norwegianNumberValidation,
            label: this.$t('message.product.discounted'),
            change: this.calculateRealCost,
            class: 'lg2 sm6'
          }, {
            model: 'other',
            loading: this.priceLoading,
            type: this.FORM_TYPE.TEXT,
            rules: this.$_norwegianNumberValidation,
            label: this.$t('message.product.other'),
            change: this.calculateRealCost,
            class: 'lg2 sm6'
          }, {
            model: 'shipmentaddon',
            type: this.FORM_TYPE.TEXT,
            loading: this.priceLoading,
            rules: this.$_norwegianNumberValidation,
            label: this.$t('message.product.shipmentAddon'),
            change: this.calculateRealCost,
            class: 'lg3 sm6'
          }, {
            model: 'realcost',
            type: this.FORM_TYPE.TEXT,
            rules: this.$_norwegianNumberValidation,
            label: this.$t('message.product.realCost'),
            class: 'lg3 sm6',
            change: this.calculateRealCost
          }, {
            model: 'realcostnok',
            type: this.FORM_TYPE.TEXT,
            loading: this.totalPriceLoading,
            rules: this.$_norwegianNumberValidation,
            label: this.$t('message.product.realCostNOK'),
            class: 'lg3 sm6'
          }, {
            model: 'ismain',
            rules: [],
            type: this.FORM_TYPE.CHECKBOX,
            class: 'lg3 sm6 my-auto',
            label: this.$t('message.product.isMain')
          }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.supplierModel.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateSupplierItemHandler(),
          loading: this.supplierLoading,
          is_show: true
        }, {
          name: 'close',
          color: 'info',
          click: () => this.closeAddNewSupplier(),
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    },
    statusList () {
      if (!this.$route.params.supp_id || !this.supplierObj.id) {
        return [{
          name: this.$t('message.common.draft'), id: CONSTANTS.DRAFT
        }]
      } else if (this.supplierObj.status !== CONSTANTS.RECEIVED && this.supplierObj.status !== CONSTANTS.PARTIALLYRECEIVED) {
        return [{
          name: this.$t('message.common.draft'), id: CONSTANTS.DRAFT
        }, {
          name: this.$t('message.common.ready'), id: CONSTANTS.READY
        }, {
          name: this.$t('message.common.ordered'), id: CONSTANTS.ORDERED
        }, {
          name: this.$t('message.common.receiving'), id: CONSTANTS.INPROGRESS
        }]
      } else {
        return [{
          name: this.$t('message.common.received'), id: CONSTANTS.RECEIVED
        }, {
          name: this.$t('message.common.partiallyReceived'), id: CONSTANTS.PARTIALLYRECEIVED
        }]
      }
    },
    formReferences () {
      return {
        title: this.$route.params.supp_id ? `${this.$t('message.whOrder.updateSupplierOrder')} (${this.supplierObj.number || ''})` : this.$t('message.whOrder.addSupplierOrder'),
        properties: [{
          model: 'supplierid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.allSuppliers,
          term: 'supplier',
          click: (term) => null,
          is_list: false,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.order.supplier'),
          class: 'lg3 sm6',
          disabled: this.disableFormFields,
          item_disabled: this.isSupplierDisabled,
          custom_item_slot: true,
          // change: this.autoSave
          change: this.findSupplierName
        }, {
          model: 'suppliercontactid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          disabled: this.disableFormFields,
          rules: [],
          items: this.listOfContacts,
          loading: this.contactsLoading,
          append_icon: this.supplierObj.supplierid ? 'add_circle' : '',
          click: (term) => this.addNewContact(),
          is_list: false,
          term: '',
          select_text: (x) => `${x.firstname || ''} ${x.lastname || ''}`,
          select_value: 'id',
          label: this.$t('message.orders.contact'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'warehouseid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          disabled: this.disableFormFields,
          rules: this.$_requiredValidation,
          items: this.listOfWarehouse,
          click: () => null,
          is_list: false,
          term: '',
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.warehouse'),
          class: 'lg2 sm6',
          // change: this.autoSave
          change: this.changesMade
        }, {
          model: 'orderdate',
          rules: this.$_requiredValidation,
          type: this.FORM_TYPE.DATEPICKER,
          class: 'lg2 sm6 xs12',
          picker: 'datePicker',
          menu: 'dateMenu',
          color: 'primary lighten-1',
          disabled: this.disableFormFields,
          label: this.$t('message.whOrder.orderDate'),
          // change: this.autoSave
          change: this.changesMade
        }, {
          model: 'estimated_date',
          rules: [],
          type: this.FORM_TYPE.DATEPICKER,
          disabled: this.supplierObj.status === CONSTANTS.RECEIVED,
          class: 'lg2 sm6 xs12',
          picker: 'dateesPicker',
          menu: 'dateesMenu',
          color: 'primary lighten-1',
          label: this.$t('message.whOrder.requested'),
          // change: this.autoSave
          change: this.changesMade
        }, {
          model: 'status',
          type: this.FORM_TYPE.SELECT,
          disabled: this.disableStatusChange,
          rules: [],
          items: this.statusList,
          term: '',
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.customer.status'),
          class: 'lg2 sm6',
          change: this.changesMade
        }, {
          model: 'responsible',
          type: this.FORM_TYPE.SELECT,
          disabled: this.disableStatusChange,
          rules: [],
          items: this.listOfUsers,
          term: '',
          select_text: 'fullname',
          select_value: 'id',
          label: this.$t('message.whOrder.ourContact'),
          class: 'lg2 sm6',
          change: this.changesMade
        }, {
          model: 'confirmed_date',
          rules: [],
          type: this.FORM_TYPE.DATEPICKER,
          disabled: this.supplierObj.status === CONSTANTS.RECEIVED,
          class: 'lg2 sm6 xs12',
          picker: 'confirmedPicker',
          menu: 'confirmedMenu',
          color: 'primary lighten-1',
          label: this.$t('message.whOrder.confirmed'),
          // change: this.autoSave
          change: this.changesMade
        }, {
          model: 'receiveddate',
          rules: [],
          type: this.FORM_TYPE.DATEPICKER,
          disabled: this.supplierObj.status === CONSTANTS.RECEIVED,
          class: 'lg2 sm6 xs12',
          picker: 'receivedPicker',
          menu: 'receivedMenu',
          color: 'primary lighten-1',
          label: this.$t('message.common.receivedDate'),
          // change: this.autoSave
          change: this.changesMade
        }, {
          model: 'priority',
          type: this.FORM_TYPE.SELECT,
          disabled: this.disableFormFields,
          rules: [],
          items: this.$_priorityList,
          term: '',
          is_list: true,
          select_text: 'text',
          select_value: 'value',
          label: this.$t('message.layout.priority'),
          class: 'lg2 sm6',
          // change: this.autoSave
          change: this.changesMade
        }, {
          model: 'file',
          type: this.FORM_TYPE.FILES,
          multiple: true,
          is_show: true,
          accept: '.xlsx, .xls, image/*, .doc, .docx, .txt, .pdf',
          label: this.$t('message.settings.standardInvoiceText'),
          slot: 'supplier_attachment',
          class: 'lg2 sm6 supplier_attachment',
          change: this.changesMade
        }, {
          model: 'custom_fields',
          class: 'lg12 xs12'
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$route.params.supp_id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveWithoutAuto(this.SAVE),
          loading: this.loading,
          is_show: true
        }, {
          name: 'action_handler_update',
          color: 'primary',
          label: this.$t('message.common.updateAndClose'),
          click: () => this.saveWithoutAuto(this.UPDATE_CLOSE),
          loading: this.loading,
          is_show: this.$route.params.supp_id
        }, {
          name: 'back_to_list',
          color: 'info',
          // eslint-disable-next-line
          click: () => this.$router.go(-1),
          label: this.$t('message.common.backToList'),
          is_show: true
        }, {
          name: 'delete_btn',
          color: 'error',
          label: this.$t('message.common.delete'),
          click: this.deleteHandler,
          disabled: this.disableStatusChange,
          is_show: this.$route.params.supp_id
        }],
        end_buttons: [
        //   {
        //   name: 'print',
        //   color: 'success',
        //   click: () => this.$parent.$parent.donwloadPrintedProducts({ ...this.supplierObj, type_ref: 'supplier' }),
        //   loading: false,
        //   label: this.$t('message.product.print'),
        //   class: 'text-right',
        //   is_show: this.supplierObj.id && this.$route.params.supp_id
        // },
          {
            name: 'download',
            color: 'success',
            click: () => this.openDownloadHandler({ ...this.supplierObj, type_ref: 'supplier' }), // this.$parent.$parent.printOrder, this.$parent.$parent.printOrder({ ...this.supplierObj, type_ref: 'supplier' }, locType),
            loading: false,
            label: this.$t('message.product.print'),
            class: 'text-right',
            is_show: this.supplierObj.id && this.$route.params.supp_id
          }, {
            name: 'share',
            color: 'info',
            label: this.$t('message.common.send'),
            click: () => this.shareHandler({ ...this.supplierObj, type_ref: 'supplier' }),
            loading: false,
            class: 'text-right',
            is_show: this.supplierObj.id && this.$route.params.supp_id
          }]
      }
    }
  },
  mounted () {
    this.supplierObj.orderdate = this.$formatter.formatDate(new Date(), 'YYYY-MM-DD', 'DD.MM.YYYY')
    this.isAutoSave = this.$route.query.autosave
    this.getGeneralSetting()
      .then((result) => {
        if (result && result.data) {
          this.companyName = result.data.partyname || ''
        }
      })
    if (this.supplierObj.id) {
      this.getSingleRecordHandler()
      window.history.pushState({ path: this.$route.path }, '', this.$route.path)
    } else {
      this.getCustomersList()
      if (this.userDetails.id && this.userDetails.id !== -100) {
        this.supplierObj.responsible = this.userDetails.id
      }
    }
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.ORDERITEMS) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        if (!data.orderItemsAutoSave) this.getSingleRecordHandler()
      } else if (data !== 'sharepoint') {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.$store.commit('isChangesMade', false)
        this.$router.push('/w_h/order')
      }
    })
    // read supporting list items
    this.$store.dispatch('getAllSuppliersIncludingInactive')
      .then((suppliers) => {
        this.allSuppliers = suppliers || []
      })
    this.$store.dispatch('getUsers')
    this.$store.dispatch('getWarehouse')
      .then(() => {
        if (!this.supplierObj.id) this.setDefaultValues({ prop: 'warehouseid', list: this.listOfWarehouse })
      })
    this.supplierObj.type = this.SUPPLIERORDER
    this.$root.$on('reloadOrderDetails', () => {
      if (this.supplierObj.id) this.getSingleRecordHandler()
    })
    /* Load if sharepoint_id not set */
    this.$root.$on('get_supplierorder_details', () => {
      this.canReloadDocument = true
      this.getSingleRecordHandler()
    })
    /* --- */
  },
  watch: {
    'supplierObj.datePicker' (val) {
      if (val) {
        this.supplierObj.orderdate = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'supplierObj.dateesPicker' (val) {
      if (val) {
        this.supplierObj.estimated_date = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'supplierObj.confirmedPicker' (val) {
      if (val) {
        this.supplierObj.confirmed_date = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'supplierObj.receivedPicker' (val) {
      if (val) {
        this.supplierObj.receiveddate = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'supplierObj.supplierid' (val) {
      if (val) {
        this.orderItems = []
        this.addProductRowHandler()
      }
    },
    'supplierObj.warehouseid' (val) {
      if (val) {
        this.getLocation(val)
      } else {
        this.listOfLocation = []
        this.clearLocationRefForWarehouse()
      }
    },
    'supplierObj.status' (val) {
      if (!val || val === CONSTANTS.DRAFT || val === CONSTANTS.READY) this.disableFormFields = false
      else this.disableFormFields = true
    },
    showProductNameSearch (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (this.$refs.productNameSearchField) {
            this.$refs.productNameSearchField.focus()
          }
        })
      }
    }
  },
  methods: {
    autoSave () {
      if (this.orderItems.length >= 1) {
        let canSave = true
        this.orderItems.every((element) => {
          if (!element.productid && !element.qty) {
            canSave = false
            return false
          } else return true
        })
        if (canSave) {
          this.qtyChanged = false
          this.saveUpdateHandler(this.SAVE, true)
        }
      }
    },
    saveWithoutAuto (type) {
      setTimeout(() => {
        if (!this.loading) this.saveUpdateHandler(type)
      }, 300)
    },
    getAllProductUnitMatrices () {
      let query = {
        expand: [{
          model: 'ProductUnit',
          on_field: 'id',
          on_parent_field: 'unitid'
        }]
      }
      this.$_executeApi('post', `productunitmatrix/query`, query)
        .then((response) => {
          this.listOfUnitMatrix = response.data
        })
    },
    getAllCurrencyList () {
      this.$_executeApi('get', `currencies/get_all_currency_list`)
        .then((response) => {
          response.data.sort((a, b) => a.name.localeCompare(b.name))
          this.listOfCurrencyList = response.data
        })
    },
    showEditUnitCostPopup (index) {
      let orders = this.orderItems
      if (orders[index]) {
        this.supplierModel.supplierid = this.$route.params.supp_id
        this.selectedProduct = orders[index]
        let productid = this.selectedProduct.productid
        let supplierid = this.supplierObj.supplierid
        if (productid) {
          this.$_executeApi('get', `productsuppliers/${productid}/${supplierid}`)
            .then((response) => {
              let transformData = { number: { list: this.supplierTransformList, format: 'replaceDotWithComma' } }
              let model = this.$_formatModel(response.data, transformData)
              if (model.id) {
                this.initStage = true
                this.supplierModel = model
                setTimeout(() => {
                  this.initStage = false
                }, 100)
                this.supplierDialog = true
                this.getCurrencyExAmount()
              }
            })
        }
      }
    },
    closeAddNewSupplier () {
      this.supplierDialog = false
    },
    saveUpdateSupplierItemHandler () {
      if (this.$refs.costItemReference.$refs.validateForm.validate()) {
        this.supplierLoading = true
        let transformData = { number: { list: this.supplierTransformList, format: 'replaceCommaWithDot' } }
        let model = this.$_formatModel(this.supplierModel, transformData)
        this.$_saveUpdateHandler('productsuppliers', model)
          .then((response) => {
            if (model.ismain) this.$eventBus.$emit('updatedSupplier', model)
            this.closeAddNewSupplier()
            if (this.supplierObj.id) this.getOrderItemsHandler(this.supplierObj.id)
            // this.statusList()
          })
          .finally(() => {
            this.supplierLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    calculateDiscounted () {
      let price = this.supplierModel.supplierprice ? this.$formatter.replaceCommaWithDot(this.supplierModel.supplierprice) : 0
      let discount = this.supplierModel.supplierdiscount ? this.$formatter.replaceCommaWithDot(this.supplierModel.supplierdiscount) : 0
      let total = price * (100 - discount) / 100
      this.supplierModel.discounted = isNaN(total) ? 0 : this.$formatter.replaceDotWithComma(total)
      this.calculateRealCost()
    },
    async calculateRealCost () {
      if (!this.initStage) {
        let discounted = this.supplierModel.discounted ? this.$formatter.replaceCommaWithDot(this.supplierModel.discounted) : 0
        let shipmentaddon = this.supplierModel.shipmentaddon ? this.$formatter.replaceCommaWithDot(this.supplierModel.shipmentaddon) : 0
        let other = this.supplierModel.other ? this.$formatter.replaceCommaWithDot(this.supplierModel.other) : 0
        let total = +discounted * (+other + 100) / 100 * (+shipmentaddon + 100) / 100
        this.supplierModel.realcost = isNaN(total) ? 0 : this.$formatter.replaceDotWithComma(total)
        this.supplierModel.realcostnok = isNaN(total) ? 0 : this.$formatter.replaceDotWithComma(total * this.totalExchangeAmount)
      }
    },
    clearLocationRefForWarehouse () {
      let productItems = this.$formatter.cloneVariable(this.orderItems)
      for (let i = 0; i < productItems.length; i++) {
        let productItem = productItems[i]
        productItem.locationid = null
        this.$set(this.orderItems, i, productItem)
      }
    },
    addProductRowHandler () {
      let getLocation = this.getLocationDefaultValue({ list: this.listOfLocation, warehouseid: this.supplierObj.warehouseid })
      this.orderItems.push({ products: [], locationid: getLocation ? getLocation.id : 0, isSelected: false, is_show: true })
    },
    // Searching products
    loadProducts (term, index, event) {
      if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term][0].lazySearch
      if (searchText) {
        this.$set(this.orderItems, index, { ...this.orderItems[index], productLoader: true })
        this.$_executeApi('get', `productpackages/get_supplierproducts_packages?supplierid=${this.supplierObj.supplierid}&search_term=${searchText}`).then((response) => {
          this.orderItems[index].products = []
          if (response.data.length > 0) {
            response.data = response.data.filter(x => !x.notinventoryitem)
            response.data.forEach(element => {
              element.productName = element.productnumber ? `${element.productnumber} - ${element.productname}` : element.productname
              element.id = element.productid
            })
            this.orderItems[index].products = response.data
          }
        }).finally(() => {
          this.$set(this.orderItems, index, { ...this.orderItems[index], productLoader: false })
        })
      }
    },
    // getWarehouseLocations (term, index, event, warehouseid) {
    //   if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
    //   let searchText = this.$refs[term][0].lazySearch
    //   this.$parent.$parent.loadLocation(searchText, index, warehouseid)
    // },
    // toggleLocations (index, actions, locationid) {
    //   this.$parent.$parent.toggleAllLocations(index, actions, locationid)
    // },
    checkIfLocationValid (index, locName) {
      this.$_executeApi('get', `/stocks/check_if_valid_location?warehouseid=${this.supplierObj.warehouseid}&locationName=${locName}`)
        .then((result) => {
          if (result && result.data > 0) {
            this.$set(this.orderItems, index, { ...this.orderItems[index], locationid: result.data })
          } else {
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.warehouse.notAValidLocation') })
            this.$set(this.orderItems, index, { ...this.orderItems[index], locationid: 0, locationname: '' })
          }
        })
    },
    loadLocation (term, index, event, productid) {
      if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term][0].lazySearch
      if (searchText && productid) {
        this.$set(this.orderItems, index, { ...this.orderItems[index], locationLoading: true })
        this.$_executeApi('get', `/stocks/get_warehouse_locations_with_stock?product_id=${productid}&warehouse_id=${this.supplierObj.warehouseid}&search_term=${searchText}`)
          .then((result) => {
            let model = result.data
            let transformData = { number: { list: ['on_stock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.location_name = `${x.location_name} (${x.on_stock})`
              x.id = x.locationid
              x.name = x.location_name
              return x
            })
            this.$set(this.orderItems, index, { ...this.orderItems[index], listOfLocation: model })
          }).finally(() => {
            this.$set(this.orderItems, index, { ...this.orderItems[index], locationLoading: false })
          })
      }
    },
    // getWarehouseLocations (term, index, event, warehouseid) {
    //   if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
    //   let searchText = this.$refs[term][0].lazySearch
    //   if (searchText !== null) {
    //     let query = {
    //       select: ['id', 'name', 'warehouseid', 'isdefault'],
    //       additionalfilters: [`name contains  '${searchText}'`],
    //       skip: 0,
    //       limit: 50,
    //       filter: `isactive eq 1 and warehouseid eq ${warehouseid}`,
    //       'order_by': {
    //         'field': 'name',
    //         'asc_or_desc': 'asc'
    //       }
    //     }
    //     this.$set(this.orderItems, index, { ...this.orderItems[index], locationLoading: true })
    //     this.$_executeApi('post', 'warehouselocations/query', query).then((response) => {
    //       let currentItem = this.orderItems[index]
    //       currentItem.listOfLocation = [...currentItem.listOfLocation, ...response.data]
    //       this.$set(this.orderItems, index, currentItem)
    //     }).finally(() => {
    //       this.$set(this.orderItems, index, { ...this.orderItems[index], locationLoading: false })
    //     })
    //   }
    // },
    async toggleLocations (index, action, locationid) {
      // this.$parent.$parent.toggleAllLocations(index, actions, locationid)
      if (locationid) {
        let items = this.$formatter.cloneVariable(this.orderItems)
        if (action === this.HIDE && items[index] && items[index].listOfLocation) {
          let locations = items[index].listOfLocation.filter(x => x.id === locationid)
          items[index].listOfLocation = locations
        }
        if (this.orderItems && this.orderItems.length > 0 && this.orderItems[index]) this.$set(this.orderItems, index, items[index])
      }
    },
    getLocation (id) {
      // let query = {
      //   select: ['id', 'name', 'warehouseid', 'isdefault'],
      //   filter: `isactive eq 1 and warehouseid eq ${id}`,
      //   'order_by': {
      //     'field': 'name',
      //     'asc_or_desc': 'asc'
      //   }
      // }
      this.clearLocationRefForWarehouse()
      // this.$_executeApi('post', 'warehouselocations/query', query).then(response => {
      //   this.listOfLocation = response.data
      //   let productItems = this.$formatter.cloneVariable(this.orderItems)
      //   let getLocation = this.getLocationDefaultValue({ list: this.listOfLocation, warehouseid: id })
      //   for (let i = 0; i < productItems.length; i++) {
      //     if (!productItems[i].locationid) {
      //       let productItem = this.orderItems[i]
      //       productItem.locationid = getLocation ? getLocation.id : 0
      //       this.$set(this.orderItems, i, productItem)
      //     }
      //   }
      // })
    },
    getSingleRecordHandler (autoSave, getOnlyModelForReport = false) {
      this.$store.commit('isChangesMade', false)
      return new Promise((resolve, reject) => {
        if (!getOnlyModelForReport) {
          if (!autoSave || !this.isAutoSave) this.fieldsLoading = true
        }
        let query = {
          expand: [{
            model: 'User',
            on_field: 'id',
            on_parent_field: 'updatedby'
          }, {
            select: ['firstname', 'lastname'],
            model: 'User',
            on_field: 'id',
            on_parent_field: 'sharedby'
          }, {
            select: ['email'],
            model: 'Customer',
            on_field: 'id',
            on_parent_field: 'supplierid'
          }, {
            select: ['name', 'isactive'],
            model: 'Customer',
            on_field: 'id',
            on_parent_field: 'deliverto'
          }, {
            select: ['firstname', 'lastname'],
            model: 'Contact',
            on_field: 'id',
            on_parent_field: 'suppliercontactid'
          }],
          filter: `id eq ${this.supplierObj.id}`
        }
        this.$_executeApi('post', `${this.WH_ORDER}/query`, query)
          .then(async (result) => {
            if (result.data) {
              this.isFromSaleOrder = false
              let transformDate = { date: { list: ['orderdate', 'estimated_date', 'confirmed_date', 'receiveddate'], from: 'DD-MM-YYYYTHH:mm:ss', to: 'DD.MM.YYYY' } }
              let model = this.$_formatModel(result.data[0], transformDate)
              var { data } = await this.getSaleOrderData(model.id)
              if (data && data.number) {
                model = { ...model, saleId: data.id, saleOrderNumber: data.number }
                this.isFromSaleOrder = true
              }
              document.title = `Lager/Ordre/${model ? model.number : ''}`
              model.suppliercontactname = `${model.contact_firstname || ''} ${model.contact_lastname || ''}`
              this.canClear = false
              this.canContactClear = false
              this.supplierObj = model
              let supplier = this.allSuppliers.find(x => x.id === this.supplierObj.supplierid)
              if (supplier) {
                this.supplierObj.supplier_name = supplier.name
                this.supplierObj.supplier_email = supplier.email
              }
              let responsible = this.listOfUsers.find(x => x.id === this.supplierObj.responsible)
              if (responsible) {
                this.supplierObj.responsible_name = `${responsible.firstname} ${responsible.lastname}`
              }
              if (this.supplierObj.deliverto) {
                this.listOfCustomers = [{ id: this.supplierObj.deliverto, name: model.customer_name, isactive: model.customer_isactive }]
                let customer = this.listOfCustomers.find(x => x.id === this.supplierObj.deliverto)
                if (customer) this.supplierObj.deliverto_name = customer.name
              }
              await this.getAddresses()
              this.getCustomerAddressData()
              this.getContacts()
              await this.getSupplierInformation()
              if (!getOnlyModelForReport) {
                if (this.supplierObj.sharepoint_id) this.getChildrenCount(this.supplierObj.sharepoint_id)
                this.disableStatusChange = false
                if (this.supplierObj.status === CONSTANTS.RECEIVED || this.supplierObj.status === CONSTANTS.PARTIALLYRECEIVED) this.disableStatusChange = true
                this.getOrderItemsHandler(this.supplierObj.id, this.isAutoSave)
                let user = ''
                if (model && this.$route.params.supp_id) {
                  this.lastUpdatedShow = true
                  user =
                  model.updatedby === -100
                    ? 'SuperAdmin'
                    : `${model.user_firstname || ''} ${model.user_lastname || ''}`
                }
                this.lastUpdated = `${
                  model && model.updatedon
                    ? `${user || ''}, ${this.$formatter.formatDate(
                      model.updatedon,
                      'DD.MM.YYYY HH:mm:ss',
                      'DD.MM.YYYY HH:mm:ss'
                    )}`
                    : ''
                }`
                this.mailSentObj = {
                  sentTo: model.sharedemailaddress,
                  sentBy: model.sharedby === -100 ? 'SuperAdmin' : `${model.user_firstname_1 || ''} ${model.user_lastname_2 || ''}`,
                  sentOn: model.sharedon ? this.$formatter.formatDate(model.sharedon, 'DD.MM.YYYY HH:mm:ss', 'DD.MM.YYYY HH:mm:ss') : ''
                }
                /*  */
                if (this.canReloadDocument) this.reInit++
                this.canReloadDocument = false
                resolve()
              } else resolve()
            }
          })
      })
    },
    getSupplierInformation () {
      return new Promise((resolve, reject) => {
        let query = {
          expand: [{
            'model': 'CustomerAddress',
            'on_field': 'customer_id',
            'on_parent_field': 'id',
            'filter': `isstandard eq 1`
          }],
          filter: `id eq '${this.supplierObj.supplierid}'`,
          'limit': 1
        }
        this.$_executeApi('post', 'customers/query', query)
          .then(response => {
            if (response && response.data && response.data[0]) {
              // eslint-disable-next-line camelcase
              const { email, language, name, customeraddress_address, customeraddress_address2, customeraddress_postcode, customeraddress_city, customeraddress_country } = response.data[0]
              const getType = this.$_orderType.find(x => x.value === this.supplierObj.type)
              const type = getType ? getType.text : this.supplierObj.type
              let model = {
                supplier_email: email,
                supplier_language: language,
                supplier_name: name,
                type,
                supplier_address: customeraddress_address,
                supplier_address2: customeraddress_address2,
                supplier_postcode: customeraddress_postcode,
                supplier_city: customeraddress_city,
                supplier_country: customeraddress_country
              }
              this.supplierObj = Object.assign({ ...this.supplierObj }, { ...model })
            }
            resolve()
          })
      })
    },
    getCustomerAddressData () {
      const addressObj = this.listOfAddress.find(x => x.id === this.supplierObj.deliveryaddress)
      if (addressObj) {
        const { address, address2, postcode, city, country } = addressObj
        let model = {
          customer_address: address,
          customer_address2: address2,
          customer_postcode: postcode,
          customer_city: city,
          customer_country: country
        }
        this.supplierObj = Object.assign({ ...this.supplierObj }, { ...model })
      }
    },
    getOrderItemsHandler (id, autoSave) {
      let url = `warehouseorderitems/get_by_order/${id}`
      this.$_executeApi('get', url)
        .then((response) => {
          let data = response.data
          let items = []
          data.forEach(async (element, index) => {
            element.products = []
            element.products.push({
              id: element.productid
            })
            element.orderedqty = element.qty * element.unitqty
            if (element.qty === element.receivedqty || element.qty < element.receivedqty) element.isMaximumUsed = true
            else element.isMaximumUsed = false
            if (this.supplierObj.status !== 'received') element.receivedqty = ''
            let receivedRef = 0
            if (!element.locationid) {
              // this.getStockHandler(index, element.productid)
            }
            if (element.receivedorders) {
              element.receivedorders.map(recElement => {
                recElement.listOfLocation = [{
                  id: recElement.locationid,
                  name: recElement.locationname
                }]
                receivedRef += recElement.receivedqty
                recElement.receivedqty = this.$formatter.replaceDotWithComma(recElement.receivedqty)
                recElement.expirydate = recElement.expirydate ? this.$formatter.formatDate(recElement.expirydate, 'DD.MM.YYYY', 'DD.MM.YYYY') : ''
                return recElement
              })
              element.receivedRef = receivedRef
              // get rest_qty value
              let allItems = element.receivedorders
              let getTotal = this.$_getSumBy(allItems, x => x.receivedqty)
              var getRestQty = (element.qty - getTotal)
              element.restqty = getRestQty || 0
            }

            element.commentReadonly = !!element.comments && this.supplierObj.status !== 'draft'

            if (element.receivedRef !== element.qty) {
              element.receivedqty = ''
              element.locationid = 0
              element.isSelected = false
              element.is_show = true
              element.olditem = this.$formatter.cloneVariable(element)
              items.push(element)
            } else {
              element.is_show = true
              element.olditem = this.$formatter.cloneVariable(element)
              items.push(element)
            }
          })
          let transformNumber = {
            number: { list: ['qty', 'minqty', 'orderedqty', 'receivedqty', 'available', 'minstock', 'discountedprice', 'costpricenok', 'discounted', 'discount'], format: 'replaceDotWithComma' },
            date: { list: ['expirydate'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' }
          }
          let modelItems = this.$_formatListModel(items, transformNumber)
          this.orderItems = modelItems
          setTimeout(() => {
            this.onScroll()
          }, 500)
          if (autoSave) {
            setTimeout(() => {
              this.$refs[`qty_${this.orderItems.length - 1}`][0].focus()
              this.isAutoSave = false
            }, 100)
          }
          this.calculateTotalValue(-1, false)
          this.filterByProductName()
          if (!autoSave) {
            this.$_executeApi('get', `/warehouseorderattachments/get_attachments/${this.supplierObj.id}`).then(response => {
              this.orderAttachment = response.data
            })
          }
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    saveUpdateHandler (type, autoSave) {
      if (this.$refs.supplierOrderRef.$refs.validateForm.validate()) {
        if (this.$refs.orderItems && this.$refs.orderItems.validate()) {
          this.loading = true
          this.saveModelData()
            .then((response) => {
              const isFirstSave = this.$formatter.cloneVariable(this.supplierObj.id)
              this.supplierObj.id = response.id
              this.supplierObj.updatedon = response.updatedon
              this.supplierObj.status = response.status
              this.$store.commit('isChangesMade', false)
              this.saveOrderItemsHandler(response.id, type, autoSave, isFirstSave)
            })
        }
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      // if (!autoSave ? this.$refs.supplierOrderRef.$refs.validateForm.validate() : true) {
      //   if (!autoSave && this.$refs.orderItems.validate()) return false
      //   let transformData = { date: { list: ['orderdate', 'estimated_date'], from: 'DD.MM.YYYY', to: 'YYYY-MM-DDTHH:mm:ss' } }
      //   let model = this.$formatter.cloneVariable(this.supplierObj)
      //   model = this.$_formatModel(model, transformData)
      //   let url = this.WH_ORDER
      //   model.type = CONSTANTS.SUPPLIER
      //   this.$_saveUpdateHandler(url, model)
      //     .then((response) => {
      //       this.$store.commit('isChangesMade', false)
      //       this.saveOrderItemsHandler(response.id, type, autoSave)
      //     })
      // } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    async saveModelData (autoSave = false) {
      let transformData = { date: { list: ['orderdate', 'estimated_date', 'confirmed_date', 'receiveddate'], from: 'DD.MM.YYYY', to: 'YYYY-MM-DDTHH:mm:ss' } }
      let model = this.$formatter.cloneVariable(this.supplierObj)
      model = this.$_formatModel(model, transformData)
      let url = this.WH_ORDER
      model.type = CONSTANTS.SUPPLIER
      try {
        const resultModel = await this.$_saveUpdateHandler(url, model, autoSave)
        this.supplierObj.updatedon = resultModel.updatedon
        return resultModel
      } catch (error) {
        this.loading = false
        return null
      }
    },
    saveOrderItemsHandler (id, type, autoSave) {
      if (this.$refs.orderItems.validate()) {
        let transformData = {
          number: { list: ['qty', 'receivedqty', 'minqty', 'unitqty', 'discountedprice', 'costpricenok', 'discount', 'discounted'], format: 'replaceCommaWithDot' }
        }
        let model = this.$formatter.cloneVariable(this.orderItems)
        model = this.$_formatListModel(model, transformData)
        model.map(x => {
          x.qty = x.qty || 0
          x.costprice = x.discountedprice || 0
          x.costpriceperunit = x.discountedprice || 0
          x.minqty = x.minqty || 0
          x.unitqty = x.unitqty || 0
          if (!x.unitqty) {
            let unitObj = this.listOfUnitMatrix.find(y => y.productid === x.productid && y.issupplier)
            if (unitObj) x.unitqty = unitObj.qty
          }
          if (x.locationid) {
            if (!x.receivedorders) x.receivedorders = []
            if (x.receivedqty) {
              x.receivedorders.push({ batchnumber: x.batchnumber,
                receivedqty: this.$formatter.replaceCommaWithDot(x.receivedqty),
                locationid: x.locationid,
                expirydate: x.expirydate })
            }
          }
          if (x.receivedorders && x.receivedorders.length > 0) {
            x.receivedorders.map(y => {
              y.receivedqty = y.receivedqty ? this.$formatter.replaceCommaWithDot(y.receivedqty) : 0
              y.expirydate = this.$formatter.formatDate(y.expirydate, 'DD.MM.YYYY', 'YYYY-MM-DD')
              return y
            })
          }
          return x
        })
        let orderItemsJSON = { 'items': this.$formatter.cloneVariable(model) }
        let url = `/warehouseorderitems/bulk_save/${id}`
        this.$_executeApi('post', url, orderItemsJSON)
          .then((response) => {
            if (this.supplierObj.file) {
              this.uploadFileHandler(type, id, autoSave)
            }
            if (autoSave) {
              this.orderItems.forEach((element, index) => {
                element.id = response.data[index].id
                element.orderid = id
              })
              if (this.orderItems.length && this.orderItems[0].locationid) {
                this.getSingleRecordHandler(autoSave)
              }
              if (this.supplierObj.status === CONSTANTS.RECEIVED || this.supplierObj.status === CONSTANTS.PARTIALLYRECEIVED) this.disableStatusChange = true
              if (!this.$route.params.supp_id) this.$router.push(`/w_h/order/supplierorder/actions/${id}?autosave=true`)
              // history.pushState({}, null, this.$route.path + '/' + id)
            }
          })
          .finally(() => {
            this.loading = false
            if (autoSave) this.getOrderItemsHandler(id)
            if (!autoSave) {
              this.navigateHandler(type, id, autoSave)
            }
          })
      } else {
        this.loading = false
        if (!autoSave) this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    getActiveProuct (index, productid) {
      // this.changesMade()
      let getProduct = this.orderItems[index].products
      if (getProduct) {
        let result = getProduct.find(x => x.id === productid)
        if (result && result.ispackage) {
          this.loadingProducts = true
          this.getProductsByPackage(productid, index)
        } else {
          let getObj = this.$formatter.cloneVariable(this.orderItems[index])
          if (getObj) {
            let unitObj = this.listOfUnitMatrix.find(x => x.productid === this.orderItems[index].productid && x.issupplier)
            if (unitObj) {
              getObj.unitid = unitObj.id
              getObj.qty = unitObj && unitObj.orderqty ? this.$formatter.replaceDotWithComma(unitObj.orderqty) : null
              getObj.minqty = unitObj && unitObj.minqty ? this.$formatter.replaceDotWithComma(unitObj.minqty) : null
              getObj.unitqty = unitObj.qty
              getObj.orderedqty = this.$formatter.replaceDotWithComma(unitObj.orderqty * unitObj.qty)
              getObj.totalprice = this.$formatter.replaceDotWithComma(((unitObj.orderqty * unitObj.qty) * (result.discounted || 0)))
            }
            getObj.minstock = this.$formatter.replaceDotWithComma(result.minstock || 0)
            getObj.available = this.$formatter.replaceDotWithComma(result.available || 0)
            getObj.isbatch = result.batchrequired
            getObj.supplierDiscount = this.$formatter.replaceDotWithComma(result.discounted || 0)
            getObj.suppliercurrency = result.currencyname || ''
            getObj.discountedprice = this.$formatter.replaceDotWithComma(result.discounted) || 0
            getObj.costpricenok = this.$formatter.replaceDotWithComma(result.realcostnok) || 0
            getObj.comments = (getObj.comments || '') + (result.drawing ? `Tegn.nr: ${result.drawing || ''}` : '')
            getObj.commentReadonly = !!getObj.comments && this.supplierObj.status !== 'draft'
            getObj.productnumber = result.productnumber
            getObj.producttext = result.productname
            this.$set(this.orderItems, index, getObj)
          }
        }
        this.autoSave()
      }
    },
    async unitCalculation (index) {
      await this.updateProductQtyValues(index, true)
      this.calculateTotalValue(index)
    },
    updateProductQtyValues (index, applyToMinQty) {
      return new Promise((resolve, reject) => {
        if (index >= 0) {
          let getObj = this.$formatter.cloneVariable(this.orderItems[index])
          let unitObj = this.listOfUnitMatrix.find(x => x.id === getObj.unitid)
          if (unitObj) {
            if (applyToMinQty) {
              getObj.qty = this.$formatter.replaceDotWithComma(unitObj.orderqty)
              getObj.minqty = this.$formatter.replaceDotWithComma(unitObj.minqty)
            }
            getObj.unitid = unitObj.id
            getObj.orderedqty = this.$formatter.replaceDotWithComma(this.$formatter.replaceCommaWithDot(getObj.qty || 0) * unitObj.qty)
            getObj.unitqty = unitObj.qty
          }
          let getExistingItems = this.$formatter.cloneVariable(this.orderItems)
          getExistingItems.splice(index, 1, getObj)
          this.orderItems = [...getExistingItems.filter(x => x)]
          resolve()
        } else resolve()
      })
    },
    getProductsByPackage (id, index) {
      this.$_executeApi('get', `productpackages/get_package_products/${id}/${this.supplierObj.supplierid || 0}`)
        .then(response => {
          let getAllProducts = []
          let list = response.data
          const conditionObj = this.isMainSupplier ? x => x.supplierid === this.supplierObj.supplierid && x.ismainsupplier : x => x.supplierid === this.supplierObj.supplierid
          list = list.filter(conditionObj)
          for (let i = 0; i < list.length; i++) {
            let unitObj = this.listOfUnitMatrix.find(x => x.productid === list[i].product.id && x.issupplier)
            let products = [{ id: list[i].product.id, productName: list[i].product.number ? `${list[i].product.number} - ${list[i].product.name}` : list[i].product.name }]
            getAllProducts.push({ products,
              productid: list[i].product.id,
              isSelected: false,
              unitid: unitObj && unitObj.id ? unitObj.id : null,
              qty: unitObj && unitObj.orderqty ? this.$formatter.replaceDotWithComma(unitObj.orderqty) : null,
              minqty: unitObj && unitObj.minqty ? this.$formatter.replaceDotWithComma(unitObj.minqty) : null,
              orderedqty: this.$formatter.replaceDotWithComma(unitObj.orderqty * unitObj.qty),
              unitqty: unitObj.qty,
              totalprice: (unitObj && unitObj.qty && list[i].supplierdiscount) ? this.$formatter.replaceDotWithComma(((unitObj.orderqty * unitObj.qty) * (list[i].supplierdiscount || 0))) : 0,
              isbatch: list[i].product.batchrequired,
              available: list[i].product.available ? this.$formatter.replaceDotWithComma(list[i].product.available) : 0,
              minstock: list[i].product.minstock ? this.$formatter.replaceDotWithComma(list[i].product.minstock) : 0,
              producttext: list[i].product.name,
              productnumber: list[i].product.number,
              productname: list[i].product.name,
              comments: list[i].product.drawing ? `Tegn.nr: ${list[i].product.drawing}` : '',
              supplierDiscount: list[i].supplierdiscount ? this.$formatter.replaceDotWithComma(list[i].supplierdiscount) : 0,
              discountedprice: list[i].supplierdiscount ? this.$formatter.replaceDotWithComma(list[i].supplierdiscount) : 0,
              costpricenok: list[i].product.costpricenok ? list[i].product.costpricenok : 0,
              suppliercurrency: list[i].suppliercurrency || '',
              olditem: this.$formatter.cloneVariable(list[i]) })
          }
          let getExistingItems = this.$formatter.cloneVariable(this.orderItems)
          getExistingItems.splice(index, 1)
          getExistingItems.push(...getAllProducts)
          this.orderItems = [...getExistingItems.filter(x => x)]
          this.loadingProducts = false
        })
        .catch((er) => {
          this.loadingProducts = false
        })
    },
    uploadFileHandler (type, id, autoSave) {
      if (this.supplierObj.file && this.supplierObj.file.length > 0) {
        let url = `warehouseorderattachments/upload/${id}`
        let formData = new FormData()
        for (let i = 0; i < this.supplierObj.file.length; i++) {
          formData.append(this.supplierObj.file[i].name, this.supplierObj.file[i])
        }
        return new Promise((resolve, reject) => {
          this.$_executeApi('post', url, formData)
            .then((response) => {
              resolve()
            })
            .finally(() => {
              this.loading = false
              this.navigateHandler(type, id)
            })
            .catch((error) => {
              reject(error)
            })
        })
      } else {
        this.supplierObj.id = id
        if (!autoSave) this.getSingleRecordHandler()
      }
      // this.navigateHandler(type, id)
    },
    checkReceivedQty (index, qty) {
      let items = this.$formatter.cloneVariable(this.orderItems)
      let allItems = items[index].receivedorders
      let getTotal = this.$_getSumBy(allItems, x => x.receivedqty)
      let qtyValue = +this.$formatter.replaceCommaWithDot(qty)
      let recQtyValue = +this.$formatter.replaceCommaWithDot(items[index].receivedqty)
      // eslint-disable-next-line
      if (qtyValue == getTotal) {
        items[index].isMaximumUsed = true
      }
      var getRestQty = (qtyValue - (getTotal + recQtyValue))
      items[index].restqty = getRestQty > 0 ? getRestQty : 0
      this.$set(this.orderItems, index, items[index])
      this.qtyChanged = true
    },
    validateQtyHandler (index, qty) {
      var totalQty = 0
      var loopCount = 0
      if (this.orderItems[index].receivedorders) {
        for (let i = 0; i < this.orderItems[index].receivedorders.length; i++) {
          if (i !== this.orderItems[index].receivedorders.length) {
            let receivedQty = this.$formatter.replaceCommaWithDot(this.orderItems[index].receivedorders[i].receivedqty)
            loopCount += parseFloat(receivedQty)
          }
        }
      }
      totalQty += parseFloat(loopCount)
      if (this.orderItems[index].receivedqty) {
        let parentReceivedQty = this.$formatter.replaceCommaWithDot(this.orderItems[index].receivedqty)
        totalQty += parseFloat(parentReceivedQty)
      }
      if (parseFloat(this.$formatter.replaceCommaWithDot(this.orderItems[index].qty)) < totalQty) {
        this.moreQtyObj = {
          dialog: true,
          onSuccess: () => {
            this.moreQtyObj.dialog = false
            this.checkReceivedQty(index, this.orderItems[index].qty)
          },
          onCancel: () => {
            totalQty = parseFloat(this.$formatter.replaceCommaWithDot(this.orderItems[index].qty)) - parseFloat(loopCount)
            this.orderItems[index].receivedqty = this.$formatter.replaceDotWithComma(totalQty)
            this.moreQtyObj.dialog = false
            this.checkReceivedQty(index, this.orderItems[index].qty)
          }
        }
      } else this.checkReceivedQty(index, this.orderItems[index].qty)
      // this.changesMade()
      // this.autoSave()
    },
    navigateHandler (type, id) {
      if (this.$route.params.supp_id && type !== this.UPDATE_CLOSE) this.getSingleRecordHandler()
      else if (type === this.SAVE && id) this.$router.push(`/w_h/order/supplierorder/actions/${id}`)
      // if (type === this.SAVE && id) this.getSingleRecordHandler()
      else if (type === this.UPDATE_CLOSE) this.$router.push('/w_h/order')
    },
    deleteHandler () {
      let ids = [this.supplierObj.id]
      let payload = { ids, url: `${this.WH_ORDER}/delete_multiple`, module: this.WH_ORDER }
      this.$store.commit('showDeleteDialog', payload)
    },
    removeSelectedProducts () {
      let getSelectedIds = this.orderItems.filter(x => x.isSelected && x.id).map(x => x.id)
      let unSavedItemsIndexes = this.orderItems.filter(x => x.isSelected && !x.id).map(x => this.orderItems.indexOf(x))
      /* Commented already
      // let getSelectedIndex =
      // this.orderItems.filter((x, index) => {
      //   if (x.isSelected && !x.id) getSelectedIndex.push(index)
      // }) */

      let availableItems = this.$formatter.cloneVariable(this.orderItems)
      this.deleteObj = {
        dialog: true,
        onSuccess: () => {
          // if (getSelectedIndex.length > 0) {
          //   availableItems = this.orderItems.filter((x, index) => !getSelectedIndex.includes(index))
          //   if (getSelectedIds.length <= 0) {
          //     this.deleteObj.dialog = false
          //     this.orderItems = availableItems
          //   }
          // }
          /* Delete unSavedItems */
          if (unSavedItemsIndexes && unSavedItemsIndexes.length > 0) {
            // const indexSet = new Set(unSavedItemsIndexes)
            availableItems = availableItems.filter((x, i) => !unSavedItemsIndexes.includes(i))
          }
          /* --- */
          /* Delete Saved items */
          if (getSelectedIds.length > 0) {
            let model = { data: { ids: getSelectedIds } }
            this.$_executeApi('delete', 'warehouseorderitems/delete_multiple', model)
              .then(response => {
                this.$root.$emit('snackbar', {
                  snackbar: true,
                  color: 'success',
                  text: this.$t('message.common.deleteMsg')
                })
                setTimeout(() => {
                  getSelectedIds.map(x => {
                    let getIndex = availableItems.findIndex(y => y.id === x)
                    if (getIndex !== -1) {
                      availableItems.splice(getIndex, 1)
                    }
                  })
                  this.orderItems = availableItems
                  this.deleteObj.dialog = false
                })
              })
          } else {
            this.$root.$emit('snackbar', {
              snackbar: true,
              color: 'success',
              text: this.$t('message.common.deleteMsg')
            })
            this.orderItems = availableItems
            this.deleteObj.dialog = false
          }
        },
        onClose: () => {
          this.deleteObj.dialog = false
        }
      }
    },
    supportingList (type, text) {
      const modelName = text
      text = this.$refs.supplierOrderRef.$refs[text][0].lazySearch
      let model = { module: type, dialog: true, text, modelName }
      this.$store.commit('supportingList', model)
    },
    // Show and Hide products in the array for performence when having more items
    toggleAllProducts (index, action, productId) {
      let items = this.$formatter.cloneVariable(this.orderItems)
      if (action === this.HIDE && items[index] && items[index].products) {
        let products = items[index].products.filter(x => x.id === productId)
        items[index].products = products
      }
      if (this.orderItems && this.orderItems.length > 0 && this.orderItems[index]) this.$set(this.orderItems, index, items[index])
      // this.autoSave()
    },
    setDefaultValues (data) {
      let { list, prop } = data
      if (list && list.length === 1) {
        let model = Object.assign({ ...this.supplierObj }, { [prop]: list[0].id })
        this.supplierObj = model
      }
    },
    getLocationDefaultValue (data) {
      let { list, warehouseid } = data
      let item = list.find(x => x.isdefault && x.warehouseid === warehouseid)
      if (item) return item
      else return null
    },
    downloadAttachment (index) {
      window.open(process.env.VUE_APP_URL + `/warehouseorderattachments/download/${this.orderAttachment[index].id}`, '_blank')
    },
    deleteAttachment (index) {
      this.$_executeApi('delete', `warehouseorderattachments/${this.orderAttachment[index].id}`).then(response => {
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'success',
          text: this.$t('message.common.deleteMsg')
        })
        this.orderAttachment.splice(index, 1)
      })
    },
    deleteProductRow (index, id) {
      if (this.orderItems[index].id) {
        let payload = { ids: [id], url: `${this.ORDERITEMS}/delete_multiple`, module: this.ORDERITEMS, orderItemsAutoSave: this.$route.params.supp_id || null }
        this.$store.commit('showDeleteDialog', payload)
      } else {
        this.orderItems.splice(index, 1)
        this.calculateTotalValue(-1, true)
      }
    },
    addProductsToList () {
      this.loadingSupplierProducts = true
      const isMainSupplier = this.isMainSupplier ? 1 : 0
      this.$_executeApi('get', `stocks/get_available_products_by_supplier/${this.supplierObj.supplierid}/${isMainSupplier}`)
        .then(response => {
          let getProducts = response.data
          let productsList = []
          getProducts.map(x => {
            x.products = [{ id: x.product.id, productName: x.product.number ? `${x.product.number} - ${x.product.name}` : x.product.name }]
            x.productid = x.product.id
            x.productnumber = x.product.number
            x.producttext = x.product.name
            x.comments = x.product.drawing ? `Tegn.nr: ${x.product.drawing}` : ''
            let unitObj = this.listOfUnitMatrix.find(y => y.productid === x.productid && y.issupplier)
            if (!unitObj) unitObj = { id: null, orderqty: 0, minqty: 0, qty: 0 }
            x.unitid = unitObj.id
            // x.qty = this.$formatter.replaceDotWithComma(x.product.unitqty || 0)
            x.qty = unitObj && unitObj.orderqty ? this.$formatter.replaceDotWithComma(unitObj.orderqty) : null
            x.minqty = unitObj && unitObj.minqty ? this.$formatter.replaceDotWithComma(unitObj.minqty) : null
            let orderedQty = 0
            if (unitObj && unitObj.orderqty) orderedQty = (unitObj.orderqty * unitObj.qty)
            orderedQty = this.$formatter.replaceDotWithComma(orderedQty)
            x.orderedqty = orderedQty
            x.unitqty = unitObj.qty
            x.minstock = this.$formatter.replaceDotWithComma(x.product.minstock || 0)
            x.available = this.$formatter.replaceDotWithComma(x.product.available || 0)
            x.isbatch = x.product.batchrequired
            x.supplierDiscount = this.$formatter.replaceDotWithComma(x.supplierdiscount || 0)
            x.discountedprice = this.$formatter.replaceDotWithComma(x.supplierdiscount || 0)
            x.costpricenok = x.product.costprice ? this.$formatter.replaceCommaWithDot(x.product.costprice) : 0
            x.olditem = this.$formatter.cloneVariable(x)
            if (!this.orderItems.find(y => y.productid === x.product.id)) productsList.push(x)
            x.id = 0
            return x
          })
          setTimeout(() => {
            let getItems = this.$formatter.cloneVariable(this.orderItems.filter(x => x.productid))
            getItems.push(...productsList)
            this.orderItems = getItems
            this.calculateTotalValue(-1, true)
          })
        })
        .finally(() => {
          this.loadingSupplierProducts = false
        })
    },

    async calculateCostNokAndTotal (index) {
      this.getCurrencyExAmount(index)
    },
    getCurrencyExAmount (index) {
      if (this.supplierCurrencyId) {
        this.$_executeApi('get', `/currencies/get_exchange_rate/${this.supplierCurrencyId}`)
          .then((response) => {
            this.totalExchangeAmount = response.data
            let items = this.orderItems
            let total = 0
            items.map((x, i) => {
              let qty = +this.$formatter.replaceCommaWithDot(x.orderedqty || 0)
              let discount = +this.$formatter.replaceCommaWithDot(x.discount || 0)
              let price
              if (x.id) {
                price = +this.$formatter.replaceCommaWithDot(x.discountedprice || 0)
              } else {
                price = +this.$formatter.replaceCommaWithDot(x.supplierDiscount || 0)
              }
              let discountedPrice = price
              let discounted = 0
              if (discount) {
                discounted = (discountedPrice - (discountedPrice * discount) / 100)
                if (!isNaN(discounted)) {
                  discountedPrice = discounted
                }
              }
              total += qty * discountedPrice
              if (index >= 0 && i === index) {
                const costNOK = price * this.totalExchangeAmount
                this.$set(this.orderItems, index, { ...this.orderItems[index], costpricenok: costNOK, discounted, totalprice: qty * discountedPrice })
              }
            })
            this.totalPrice = total
          })
      } else {
        this.calculateTotalValue(index)
      }
    },
    calculateTotalValue (index, init = false) {
      this.updateProductQtyValues(index)
      let items = this.orderItems
      let total = 0
      let suppliercurrency = ''
      let suppliercurrencyid = 0
      items.map((x, i) => {
        suppliercurrency = x.suppliercurrency
        suppliercurrencyid = x.suppliercurrencyid
        let qty = +this.$formatter.replaceCommaWithDot(x.orderedqty || 0)
        let discount = +this.$formatter.replaceCommaWithDot(x.discount || 0)
        let price
        if (x.id) {
          price = +this.$formatter.replaceCommaWithDot(x.discountedprice || 0)
        } else {
          price = +this.$formatter.replaceCommaWithDot(x.supplierDiscount || 0)
        }
        let discountedPrice = price
        let discounted = 0
        if (discount) {
          discounted = (discountedPrice - (discountedPrice * discount) / 100)
          if (discounted) {
            discountedPrice = discounted
          }
        }
        total += qty * discountedPrice
        if (index >= 0 && i === index) {
          this.$set(this.orderItems, i, { ...this.orderItems[index], discounted, totalprice: qty * discountedPrice })
        } else if (init) {
          this.$set(this.orderItems, i, { ...this.orderItems[i], discounted, totalprice: qty * discountedPrice })
        }
      })
      this.totalPrice = total
      this.supplierCurrency = suppliercurrency
      this.supplierCurrencyId = suppliercurrencyid
    },
    // Receive all available products with location and Qty
    receiveAllHandler () {
      if (this.supplierObj.id) {
        this.receiveAllLoader = true
        this.$_executeApi('post', `warehouseorders/get_receivable_items_location/${this.supplierObj.id}`)
          .then((response) => {
            if (response && response.data) {
              const availableItems = response.data || []
              const allItems = this.$formatter.cloneVariable(this.orderItems)
              allItems.map(x => {
                const qtyFormat = +this.$formatter.replaceCommaWithDot(x.qty)
                const itemObj = availableItems.find(y => y.orderitemid === x.id)
                if (itemObj && !x.productnotinventoryitem) {
                  x.listOfLocation = [{
                    id: itemObj.locationid,
                    name: itemObj.locationname
                  }]
                  x.locationid = itemObj.locationid
                  x.locationname = itemObj.locationname
                  x.receivedqty = x.qty
                  x.restqty = qtyFormat - qtyFormat
                } else {
                  x.receivedqty = x.qty
                  x.restqty = qtyFormat - qtyFormat
                }
                const restQtyFormat = this.$formatter.replaceDotWithComma(x.restqty)
                x.restqty = restQtyFormat
                return x
              })
              this.orderItems = allItems
            }
          }).finally(() => {
            this.receiveAllLoader = false
          })
      }
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    },
    getChildrenCount (id) {
      this.attachmentsCountLoading = true
      this.$_executeApi('get', `sharepoint/get_folder/${id}`)
        .then((response) => {
          if (response && response.data) this.attachmentsCount = response.data.childcount
        }).finally(() => {
          this.attachmentsCountLoading = false
        })
    },
    findSupplierName () {
      let supplier = this.allSuppliers.find(x => x.id === this.supplierObj.supplierid)
      if (supplier) this.supplierObj.supplier_name = supplier.name
      this.getContacts()
    },
    findDeliverToName () {
      let customer = this.listOfCustomers.find(x => x.id === this.supplierObj.deliverto)
      if (customer) this.supplierObj.deliverto_name = customer.name
      this.getAddresses()
    },
    isCustomerDisabled (item) {
      return !item.isactive
    },
    isSupplierDisabled (item) {
      return !item.isactive
    },
    getSaleOrderData (id) {
      return this.$_executeApi('get', `warehouseorders/get_sale_order/${id}`)
    },
    // Searching suppliers
    loadCustomers (term, event) {
      if ([32, 37, 38, 39, 40].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term].lazySearch
      let model = {
        'filter': `name contains '${searchText}'`,
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        },
        'skip': 0,
        'limit': 50
      }
      this.customersLoading = true
      this.$_executeApi('post', 'customers/query', model)
        .then((response) => {
          this.listOfCustomers = response.data
        })
        .finally(() => {
          this.customersLoading = false
        })
    },
    getCustomersList () {
      this.customersLoading = true
      const query = { filter: 'iscustomer eq 1', order_by: { field: 'name', asc_or_desc: 'asc' } }
      return this.$_executeApi('post', 'customers/query', query)
        .then(response => {
          this.listOfCustomers = response.data || []
        })
        .finally(() => {
          this.customersLoading = false
        })
    },
    getGeneralSetting () {
      return this.$_executeApi('get', 'commonsettings')
    },
    getStockHandler (index, productid) {
      this.loadingLocations = true
      this.$_executeApi('get', `/stocks/get_product_by_warehouse?product_id=${productid}&warehouse_id=${this.supplierObj.warehouseid || 0}`)
        .then((result) => {
          let model = result.data
          model = model.filter(x => x.on_stock > 0)
          let transformData = { number: { list: ['on_stock'], format: 'replaceDotWithComma' } }
          model = this.$_formatListModel(model, transformData)
          model.map(x => {
            x.location_name = `${x.location_name} (${x.on_stock})`
            x.id = x.locationid
            x.name = x.location_name
            return x
          })
          const modelObj = { ...this.orderItems[index] }
          if (model.length === 1) {
            modelObj.locationid = model[0].id
          }
          this.$set(this.orderItems, index, { ...modelObj, listOfLocation: model })
          this.loadingLocations = false
        })
        .catch((err) => {
          console.log(err)
          this.loadingLocations = false
        })
    },
    getAddresses (id = 0) {
      if (this.supplierObj.deliverto) {
        this.addressLoading = true
        let query = { filter: `customer_id eq ${this.supplierObj.deliverto}`, order_by: { field: 'address', asc_or_desc: 'asc' } }
        return this.$_executeApi('post', `customeraddresses/query`, query)
          .then(response => {
            if (!this.supplierObj.id || this.canClear) { this.supplierObj.deliveryaddress = 0 }
            this.listOfAddress = response.data
            if (this.supplierObj.id) this.canClear = true
            if (id) this.supplierObj.deliveryaddress = id
          })
          .finally(() => {
            this.addressLoading = false
          })
      } else {
        this.listOfAddress = []
        this.supplierObj.deliveryaddress = 0
        return Promise.resolve()
      }
    },
    getContacts (id = 0) {
      if (this.supplierObj.supplierid) {
        this.contactsLoading = true
        let query = { filter: `customer_id eq ${this.supplierObj.supplierid}`, order_by: { field: 'firstname', asc_or_desc: 'asc' } }
        return this.$_executeApi('post', `contacts/query`, query)
          .then(response => {
            if (!this.supplierObj.id || this.canContactClear) { this.supplierObj.suppliercontactid = 0 }
            this.listOfContacts = response.data
            if (this.supplierObj.id) this.canContactClear = true
            const contactObj = this.listOfContacts.find(x => x.id === this.supplierObj.suppliercontactid)
            if (contactObj) {
              this.supplierObj.suppliercontactname = `${contactObj.firstname || ''} ${contactObj.lastname || ''}`
            }
            if (id) {
              this.supplierObj.suppliercontactid = id
            }
          })
          .finally(() => {
            this.contactsLoading = false
          })
      } else {
        this.listOfContacts = []
        this.supplierObj.suppliercontactid = 0
        return Promise.resolve()
      }
    },
    getCombinedAddress (obj) {
      let addressItems = (({ address, address2, postcode, city }) => ({
        address,
        address2,
        postcode,
        city
      }))(obj)
      return this.getCommaStringFromObj(addressItems)
    },
    async shareHandler (item) {
      await this.saveModelData(true)
      await this.getSingleRecordHandler(false, true)
      let responsible = this.listOfUsers.find(x => x.id === this.supplierObj.responsible)
      if (responsible) {
        this.supplierObj.responsible_name = `${responsible.firstname} ${responsible.lastname}`
      }
      this.$parent.$parent.sendReport({ ...this.supplierObj, type_ref: 'supplier' })
    },
    openDownloadHandler (item) {
      this.downloadObj = {
        dialog: true,
        model: item,
        withPrices: false,
        withLocs: false,
        onSuccess: async () => {
          await this.saveModelData(true)
          await this.getSingleRecordHandler(false, true)
          let responsible = this.listOfUsers.find(x => x.id === this.supplierObj.responsible)
          if (responsible) {
            this.supplierObj.responsible_name = `${responsible.firstname} ${responsible.lastname}`
          }
          this.$parent.$parent.printOrder({ ...this.supplierObj, type_ref: 'supplier' }, this.downloadObj)
          this.downloadObj.dialog = false
        },
        onClose: () => {
          this.downloadObj.dialog = false
        }
      }
    },
    getCommaStringFromObj (obj) {
      Object.keys(obj).forEach(key => !obj[key] && delete obj[key])
      return Object.values(obj).join(', ')
    },
    addNewAddress () {
      this.addressDialog = true
      this.addressModel = { isstandard: true, type: 'delivery' }
    },
    closeAddNewAddress () {
      this.addressDialog = false
      this.addressLoading = false
      this.addressModel.id = undefined
      this.$refs.addressReference.$refs.validateForm.reset()
    },
    saveUpdateAddressHandler () {
      if (this.$refs.addressReference.$refs.validateForm.validate()) {
        this.addressLoading = true
        let model = this.addressModel
        model.customer_id = this.supplierObj.deliverto
        this.$_saveUpdateHandler('customeraddresses', model)
          .then(response => {
            this.addressDialog = false
            this.addressModel.id = undefined
            this.$refs.addressReference.$refs.validateForm.reset()
            this.getAddresses(response.id)
          })
          .finally(() => {
            this.addressLoading = false
          })
      } else {
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'error',
          text: this.$t('message.common.validationIssue')
        })
      }
    },
    addNewContact () {
      this.contactDialog = true
      this.contactModel = { isactive: true }
    },
    closeAddNewContact () {
      this.contactDialog = false
      this.contactLoading = false
      this.contactModel.id = undefined
      this.$refs.contactReference.$refs.validateForm.reset()
    },
    saveUpdateContactHandler () {
      if (this.$refs.contactReference.$refs.validateForm.validate()) {
        this.contactLoading = true
        let model = this.contactModel
        model.customer_id = this.supplierObj.supplierid
        this.$_saveUpdateHandler('contacts', model)
          .then(response => {
            this.contactDialog = false
            this.contactModel.id = undefined
            this.$refs.contactReference.$refs.validateForm.reset()
            this.getContacts(response.id)
          })
          .finally(() => {
            this.contactLoading = false
          })
      } else {
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'error',
          text: this.$t('message.common.validationIssue')
        })
      }
    },
    // Search from city API
    loadAllCityByPost () {
      if (this.addressModel.postcode) {
        this.isLoading = true
        const key = process.env.VUE_APP_LOOKUP_CITY_KEY.toString()
        // const user = process.env.VUE_APP_LOOKUP_CITY_USER.toString()
        const options = {
          method: 'GET',
          headers: {
            'X-Mybring-API-Key': key,
            'X-MyBring-API-Uid': 'vitali@avalia.no'
          }
        }

        fetch(`${process.env.VUE_APP_LOOKUP_CITY_URL}${this.addressModel.postcode || ''}.json`, options)
          .then(response => response.json())
          .then(response => {
            const { postalCode } = response
            this.cityList = []
            const cityValues = []
            if (postalCode) {
              postalCode.map(x => {
                cityValues.push(x.city)
              })
            }
            this.cityList = cityValues
            if (cityValues && cityValues.length === 1) {
              this.$set(this.addressModel, 'city', cityValues[0])
            } else {
              this.$set(this.addressModel, 'city', '')
            }
            this.isLoading = false
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    onPasteLocation (evnt, pastedIndex) {
      const pastedData = evnt.clipboardData || window.clipboardData
      const copiedLocation = pastedData.getData('Text')
      let selectedItems = this.orderItems.filter(x => x.checked) || []
      if (selectedItems && selectedItems.length > 0) {
        selectedItems.map(x => {
          const resultIdx = this.orderItems.findIndex(y => y.id === x.id)
          if (resultIdx !== -1 && resultIdx !== pastedIndex) {
            this.$set(this.orderItems, resultIdx, { ...this.orderItems[resultIdx], locationname: copiedLocation, checked: false })
          }
          this.$set(this.orderItems, resultIdx, { ...this.orderItems[resultIdx], checked: false })
        })
      }
    },
    pasteLocationsGlobally (evt, index, key) {
      var list = this.$formatter.cloneVariable(this.orderItems)
      if (key === 'ctrl') {
        if (!list[index].receivedorders.some(x => x.locationid)) {
          let update = Object.assign(list[index], { checked: !list[index]['checked'] })
          this.$set(this.orderItems, index, update)
        }
      } else if (key === 'shift') {
        let selectedItems = list.filter(x => x.checked) || []
        let item = selectedItems.length > 0 ? selectedItems[selectedItems.length - 1] : { id: -1 }
        let betweenIndex = list.findIndex(x => x.id === item.id)
        let tillItemIndex = index
        let startIndex = 0
        let endIndex = 0
        if (betweenIndex < tillItemIndex) {
          startIndex = betweenIndex
          endIndex = tillItemIndex
        } else {
          startIndex = tillItemIndex
          endIndex = betweenIndex
        }
        if (list && list[startIndex]) {
          for (let i = startIndex; i <= endIndex; i++) {
            if (!list[i].receivedorders.some(x => x.locationid)) {
              let update = Object.assign(list[i], { checked: true })
              this.$set(this.orderItems, i, update)
            }
          }
        }
      } else {
        for (let i = 0; i < list.length; i++) {
          if (i !== index) {
            list[i]['checked'] = false
          } else {
            list[i]['checked'] = true
          }
          this.$set(this.orderItems, i, list[i])
        }
      }
      const inputControl = document.elementFromPoint(evt.x, evt.y)
      if (inputControl) {
        inputControl.blur()
        requestAnimationFrame(() => {
          setTimeout(() => {
            inputControl.focus()
          }, 500)
        })
      }
    },
    fillOutLocations () {
      let firstLocation = this.orderItems && this.orderItems[0] ? this.orderItems[0] : {}
      if (firstLocation && firstLocation.locationid && firstLocation.locationname) {
        let selectedItems = this.orderItems.filter(x => x.receivedorders && x.receivedorders.length === 0)
        selectedItems.map(x => {
          const resultIdx = this.orderItems.findIndex(y => y.id === x.id)
          this.$set(this.orderItems, resultIdx, { ...this.orderItems[resultIdx], locationname: firstLocation.locationname, locationid: firstLocation.locationid, checked: false })
        })
      }
    },
    onScroll () {
      if (window.pageYOffset <= 0) this.showScrollToTop = false
      else this.showScrollToTop = true
      setTimeout(() => {
        this.onResize()
      })
    },
    onResize () {
      this.showScrollToBottom = window.innerWidth > document.documentElement.clientWidth
    },
    scrollToTop () {
      goTo(0)
    },
    goToBottom () {
      goTo(this.pageHeight)
    },
    reverseTheStock (receivedId) {
      // Reverse the stock
      this.reverseHandler = {
        dialog: true,
        loading: false,
        onSuccess: () => {
          this.reverseHandler.loading = true
          this.$_executeApi('post', `warehouseorderitems/reverse_received/${receivedId}`, {})
            .then(({ data }) => {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.actionPerformed') })
            })
            .finally(() => {
              this.reverseHandler.loading = false
              this.reverseHandler.dialog = false
              this.getSingleRecordHandler()
            })
        },
        onCancel: () => {
          this.reverseHandler.dialog = false
        }
      }
    },
    handleProductNameSearchBlur () {
      // Hide search field only if no search text is entered
      if (!this.productNameSearchText || this.productNameSearchText.trim() === '') {
        this.showProductNameSearch = false
      }
    },
    filterByProductName () {
      // Clear any existing debounce timer
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
      }

      const searchText = (this.productNameSearchText || '').toLowerCase().trim()

      if (!searchText) {
        // If search is empty, reset immediately without delay - show all items
        for (let i = 0; i < this.orderItems.length; i++) {
          this.$set(this.orderItems[i], 'is_show', true)
        }
        return
      }

      // Add 500ms delay before triggering search
      this.searchDebounceTimer = setTimeout(() => {
        // Apply search filter to orderItems based on producttext
        for (let i = 0; i < this.orderItems.length; i++) {
          const item = this.orderItems[i]
          const productText = (item.producttext || '').toLowerCase()
          const matches = productText.includes(searchText)

          // Update is_show flag without modifying the actual data
          this.$set(this.orderItems[i], 'is_show', matches)
        }
      }, 500)
    },
    exportOrderItems () {
      this.exportLoading = true

      // Check if product name search is active
      const hasProductNameSearch = this.productNameSearchText && this.productNameSearchText.trim()

      // If search is active, collect IDs of visible items
      let payload = []
      if (hasProductNameSearch) {
        // Get IDs of all visible order items (is_show = true)
        const visibleItemIds = this.orderItems
          .filter(x => x.is_show && x.id && x.productid)
          .map(x => x.id)

        if (visibleItemIds.length === 0) {
          this.exportLoading = false
          this.$root.$emit('snackbar', {
            snackbar: true,
            color: 'warning',
            text: this.$t('message.common.noResults')
          })
          return
        }

        payload = visibleItemIds
      }

      // Call API with or without filtered IDs
      this.$_executeApi('post', `warehouseorderitems/export_order_items/${this.supplierObj.id}`, payload)
        .then((response) => {
          this.$_downloadExportedReport(response.data).then(() => {
            this.exportLoading = false
          })
        })
        .catch(() => {
          this.exportLoading = false
        })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    // Clear debounce timer to prevent memory leaks
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer)
      this.searchDebounceTimer = null
    }
    this.$eventBus.$off('deleteSuccess')
    this.$root.$off('reloadOrderDetails')
    this.$root.$off('get_supplierorder_details')
  }
}
</script>
<style>
.order_item_table.v-data-table th {
  padding: 0 2px !important;
}
.order_item_table.v-data-table td {
  padding: 0 2px !important;
}
.order_item_table .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  font-size: 14px;
  padding: 0 3px !important;
}
.order_item_table .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 35px !important;
}
.order_item_table .product-search.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 20px !important;
}
.custom-max-width div#spDoc > div {
  max-width: 100%;
}
.supplier_attachment .v-text-field__details {
  display: none !important;
}
.highlight-location {
  background: #d3d0d0;
  border: 1px dashed #7e7e7e;
}
</style>
